// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1Huel","notes":"Notes_notes__1k7-p","note":"Notes_note__18r4Z","markdown":"Notes_markdown__3yWim"};